import React, { useState, useEffect, useRef, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { RxCross2 } from "react-icons/rx";
import appLogo from "../assets/img/app_logo.png";
import Navigation from "./OffCanvasRightComponents/Navigation";
import { MdPermMedia } from "react-icons/md";
import Person from "./Person";
import { AuthContext } from "../contexts/AuthContext";
import { socket } from "../services/socket";
import { idsEqual } from "../services/idUtils";

export default function OffCanvasRightGroupe({
  setDisplayOffCanvasRight,
  displayOffCanvasRight,
  crew,
  setCrew,
  allMessages,
}) {
  const { user } = useContext(AuthContext);
  const navigate = useNavigate();
  const [displayTabContent, setDisplayTabContent] = useState(false);
  const boxRefOffCanvasRight = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (
        boxRefOffCanvasRight.current &&
        !boxRefOffCanvasRight.current.contains(event.target)
      ) {
        setDisplayOffCanvasRight(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Écouter les events socket pour mettre à jour crew en temps réel
  useEffect(() => {
    const handleInfoUpdated = ({ groupe }) => {
      if (setCrew && crew && idsEqual(groupe._id, crew.id)) {
        setCrew((prev) => ({
          ...prev,
          nom: groupe.groupeInfo.nom,
          imageUrl: groupe.groupeInfo.imageUrl,
          description: groupe.groupeInfo.description,
        }));
      }
    };

    const handleMembreAdded = ({ groupe }) => {
      if (setCrew && crew && idsEqual(groupe._id, crew.id)) {
        setCrew((prev) => ({
          ...prev,
          membres: groupe.membres,
          membresIds: groupe.membres.map((m) => m.userId),
        }));
      }
    };

    const handleMembreRemoved = ({ groupe, removedMembreId }) => {
      if (setCrew && crew && idsEqual(groupe._id, crew.id)) {
        if (idsEqual(removedMembreId, user.userId)) {
          setCrew(null);
          setDisplayOffCanvasRight(false);
        } else {
          setCrew((prev) => ({
            ...prev,
            membres: groupe.membres,
            membresIds: groupe.membres.map((m) => m.userId),
          }));
        }
      }
    };

    const handleMembreMuted = ({ roomId, groupe: g }) => {
      if (setCrew && crew && crew.roomId === roomId) {
        setCrew((prev) => ({ ...prev, mutedMembers: g.mutedMembers || [] }));
      }
    };

    socket.on("groupe_info_updated", handleInfoUpdated);
    socket.on("membre_added_to_groupe", handleMembreAdded);
    socket.on("membre_removed_from_groupe", handleMembreRemoved);
    socket.on("membre_muted_in_groupe", handleMembreMuted);

    return () => {
      socket.off("groupe_info_updated", handleInfoUpdated);
      socket.off("membre_added_to_groupe", handleMembreAdded);
      socket.off("membre_removed_from_groupe", handleMembreRemoved);
      socket.off("membre_muted_in_groupe", handleMembreMuted);
    };
  }, [crew, setCrew, user.userId, setDisplayOffCanvasRight]);

  if (!crew) return null;

  return (
    <>
      <div
        ref={boxRefOffCanvasRight}
        className={`tyn-chat-content-aside ${
          displayOffCanvasRight
            ? "show-aside animate__fadeInRightBig animate__animated"
            : ""
        }`}
        id="tynChatAside"
        data-simplebar
      >
        <div className="simplebar-wrapper" style={{ margin: 0 }}>
          <div className="simplebar-height-auto-observer-wrapper">
            <div className="simplebar-height-auto-observer"></div>
          </div>
          <div className="simplebar-mask">
            <div
              className="simplebar-offset"
              style={{ right: "0px", bottom: "0px" }}
            >
              <div
                className="simplebar-content-wrapper"
                tabIndex="0"
                role="region"
                aria-label="scrollable content"
                style={{ height: "100%", overflowY: "auto" }}
              >
                <div className="simplebar-content" style={{ padding: "0px" }}>
                  {/* Section 1 : En-tête groupe */}
                  <div className="tyn-chat-cover d-flex justify-content-center mt-3">
                    <img
                      src={appLogo}
                      alt="app_logo"
                      className="animate__animated animate__pulse animate__infinite my-tyn-logo"
                      style={{ height: "248px", width: "260px" }}
                    />
                  </div>

                  <div className="tyn-media-group tyn-media-vr tyn-media-center mt-n4">
                    <div className="tyn-media tyn-size-xl border border-2 border-white">
                      <Person
                        person={{
                          image: crew.imageUrl,
                          nom: crew.nom?.[1] || "",
                          prenom: crew.nom || "",
                          userId: crew.id,
                          colors: crew.color,
                        }}
                      />
                    </div>
                    <div className="tyn-media-col">
                      <div className="tyn-media-row">
                        <h6 className="name">{crew.nom}</h6>
                      </div>
                    </div>
                  </div>

                  {/* Lien vers la page de détails */}
                  <div className="text-center mt-2 mb-2">
                    <button
                      className="btn btn-sm btn-outline-primary"
                      onClick={() => {
                        setDisplayOffCanvasRight(false);
                        navigate(`/groupes/${crew.roomId}`);
                      }}
                    >
                      Gérer le groupe
                    </button>
                  </div>

                  {/* Section Média */}
                  <div className="tyn-aside-row">
                    <ul className="nav nav-btns nav-btns-stretch nav-btns-light">
                      <li className="nav-item">
                        <button
                          className="nav-link"
                          data-bs-toggle="tab"
                          data-bs-target="#chat-media"
                          type="button"
                          onClick={() =>
                            setDisplayTabContent(!displayTabContent)
                          }
                        >
                          <MdPermMedia />
                          <span>Média</span>
                        </button>
                      </li>
                    </ul>
                  </div>

                  <div
                    className={`${
                      displayTabContent
                        ? "tab-content animate__animated animate__slideInUp"
                        : "animate__animated animate__fadeOutDown "
                    }`}
                  >
                    <div
                      className="tab-pane active show"
                      id="chat-media"
                      tabIndex="0"
                    >
                      <Navigation
                        myClassName="py-0"
                        linksNavigates={["Images", "Documents", "Liens"]}
                        details={true}
                        allMessages={allMessages}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <button
          className={`btn bg-danger text-white btn-md btn-icon btn-pill btn-white shadow position-absolute ${
            !displayOffCanvasRight ? "d-none" : ""
          }`}
          style={{ top: "27px", left: "-33px" }}
          onClick={() => {
            setDisplayOffCanvasRight(false);
          }}
        >
          <RxCross2 />
        </button>
      </div>
    </>
  );
}
